import { CHANNELS } from 'shared/constants';
import { ConditionsType } from 'shared/types';

type SubComponentType = {
  placeholder: string;
  options?: ConditionsType[];
  type?: string;
};

export type FieldType = {
  id: string;
  key: string;
  groupId?: string;
  name: string;
  type: string;
  label?: string;
  uniqueId?: string;
  options: any;
  placeholder: string;
  defaultValue: any;
  subComponent?: SubComponentType;
};

export const FILTER_CONDITIONS: ConditionsType[] = [
  {
    id: 'is',
    name: 'filter_operations.is',
    value: '=',
    isConditional: true,
    conditionType: 'DROPDOWN',
  },
  {
    id: 'is_empty',
    name: 'filter_operations.is_empty',
    value: '=\u0000',
    isConditional: true,
    conditionType: 'NONE',
  },
  {
    id: 'gt',
    name: 'filter_operations.greater_than',
    value: `${encodeURIComponent('[gt]')}=`,
    isConditional: true,
    conditionType: 'DROPDOWN',
  },
  {
    id: 'lt',
    name: 'filter_operations.less_than',
    value: `${encodeURIComponent('[lt]')}=`,
    isConditional: true,
    conditionType: 'DROPDOWN',
  },
  {
    id: 'gte',
    name: 'filter_operations.greater_than_or_equals',
    value: `${encodeURIComponent('[gte]')}=`,
    isConditional: true,
    conditionType: 'DROPDOWN',
  },
  {
    id: 'lte',
    name: 'filter_operations.less_than_or_equals',
    value: `${encodeURIComponent('[lte]')}=`,
    isConditional: true,
    conditionType: 'DROPDOWN',
  },
];

export const FILTER_NUMBER_CONDITIONS: ConditionsType[] = [
  {
    id: 'is',
    name: 'filter_operations.is',
    value: '=',
    isConditional: true,
    conditionType: 'NUMBER',
  },
  {
    id: 'gt',
    name: 'filter_operations.greater_than',
    value: `${encodeURIComponent('[gt]')}=`,
    isConditional: true,
    conditionType: 'NUMBER',
  },
  {
    id: 'lt',
    name: 'filter_operations.less_than',
    value: `${encodeURIComponent('[lt]')}=`,
    isConditional: true,
    conditionType: 'NUMBER',
  },
  {
    id: 'gte',
    name: 'filter_operations.greater_than_or_equals',
    value: `${encodeURIComponent('[gte]')}=`,
    isConditional: true,
    conditionType: 'NUMBER',
  },
  {
    id: 'lte',
    name: 'filter_operations.less_than_or_equals',
    value: `${encodeURIComponent('[lte]')}=`,
    isConditional: true,
    conditionType: 'NUMBER',
  },
];

export const RATING_TYPES = [
  'nps_rating',
  'csat_rating',
  'ces_rating',
  'nps_rating_group',
  'csat_rating_group',
  'ces_rating_group',
  'prev_nps_rating',
  'prev_csat_rating',
  'prev_ces_rating',
  'prev_nps_rating_group',
  'prev_csat_rating_group',
  'prev_ces_rating_group',
];

export const RATING_GROUP: ConditionsType[] = [
  {
    id: 'promoter',
    name: 'Is Promoter',
    value: {
      start: 9,
      end: 10,
    },
    type: 'range',
  },
  {
    id: 'passive',
    name: 'Is Passive',
    value: {
      start: 7,
      end: 8,
    },
    type: 'range',
  },
  {
    id: 'detractor',
    name: 'Is Detractor',
    value: {
      start: 0,
      end: 6,
    },
    type: 'range',
  },
];

export const DATETIME: ConditionsType[] = [
  {
    id: 'today',
    name: 'filter_operations.today',
    value: {},
    type: 'DATERANGE',
    isConditional: false,
  },
  {
    id: 'yesterday',
    name: 'filter_operations.yesterday',
    value: {},
    type: 'DATERANGE',
    isConditional: false,
  },
  {
    id: 'last7days',
    name: 'filter_operations.Last_7_days',
    value: {},
    type: 'DATERANGE',
    isConditional: false,
  },
  {
    id: 'last30days',
    name: 'filter_operations.Last_30_days',
    value: {},
    type: 'DATERANGE',
    isConditional: false,
  },
  {
    id: 'lt',
    name: 'filter_operations.before',
    value: `${encodeURIComponent('[lt]')}=`,
    isConditional: true,
    conditionType: 'DATE_TIME',
  },
  {
    id: 'gt',
    name: 'filter_operations.after',
    value: `${encodeURIComponent('[gt]')}=`,
    isConditional: true,
    conditionType: 'DATE_TIME',
  },
  {
    id: 'timeperiod',
    name: 'filter_operations.select_time_period',
    value: {},
    type: 'DATERANGE',
    isConditional: true,
    conditionType: 'DATERANGE',
  },
];

export const CHECK_TRUTH: ConditionsType[] = [
  {
    id: 'true',
    name: 'true',
    value: 'true',
  },
  {
    id: 'false',
    name: 'false',
    value: 'false',
  },
];

export const COMMENT_OPTIONS: ConditionsType[] = [
  {
    id: 'true',
    name: 'responses.filter_condition.comment.with',
    value: 'true',
  },
  {
    id: 'false',
    name: 'responses.filter_condition.comment.without',
    value: 'false',
  },
];

export const RATING: ConditionsType[] = [
  { id: '0', name: '0', value: '0' },
  { id: '1', name: '1', value: '1' },
  { id: '2', name: '2', value: '2' },
  { id: '3', name: '3', value: '3' },
  { id: '4', name: '4', value: '4' },
  { id: '5', name: '5', value: '5' },
  { id: '6', name: '6', value: '6' },
  { id: '7', name: '7', value: '7' },
  { id: '8', name: '8', value: '8' },
  { id: '9', name: '9', value: '9' },
  { id: '10', name: '10', value: '10' },
];

export const STATUS_OPTIONS: ConditionsType[] = [
  {
    id: 'PARTIAL_COMPLETE',
    name: 'responses.filter_condition.status.partial',
    value: 'PARTIAL_COMPLETE',
  },
  {
    id: 'COMPLETE',
    name: 'responses.filter_condition.status.complete',
    value: 'COMPLETE',
  },
];

export const ResponseFields: Array<FieldType> = [
  {
    id: 'status',
    key: 'status',
    groupId: 'ALL',
    name: 'responses.filter_condition.response_fields.response_status',
    type: 'DROPDOWN',
    options: STATUS_OPTIONS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'created_at',
    key: 'created_at',
    groupId: 'ALL',
    name: 'responses.filter_condition.response_fields.responded',
    type: 'DROPDOWN',
    options: DATETIME,
    placeholder: 'forms.placeholders.any_time',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.select_date',
    },
  },
  {
    id: 'ratings.nps_rating',
    key: 'nps_rating',
    groupId: 'NPS',
    name: 'responses.filter_condition.response_fields.rating',
    type: 'DROPDOWN',
    options: FILTER_CONDITIONS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.select_rating',
      options: [],
    },
  },
  {
    id: 'ratings.csat_rating',
    key: 'csat_rating',
    groupId: 'CSAT',
    name: 'responses.filter_condition.response_fields.rating',
    type: 'DROPDOWN',
    options: FILTER_CONDITIONS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.select_rating',
      options: [],
    },
  },
  {
    id: 'ratings.ces_rating',
    key: 'ces_rating',
    groupId: 'CES',
    name: 'responses.filter_condition.response_fields.rating',
    type: 'DROPDOWN',
    options: FILTER_CONDITIONS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.select_rating',
      options: [],
    },
  },
  {
    id: 'ratings.nps_rating_group',
    key: 'nps_rating_group',
    groupId: 'NPS',
    name: 'responses.filter_condition.response_fields.rating_group',
    type: 'DROPDOWN',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'ratings.csat_rating_group',
    key: 'csat_rating_group',
    groupId: 'CSAT',
    name: 'responses.filter_condition.response_fields.rating_group',
    type: 'DROPDOWN',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'ratings.ces_rating_group',
    key: 'ces_rating_group',
    groupId: 'CES',
    name: 'responses.filter_condition.response_fields.rating_group',
    type: 'DROPDOWN',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'ratings.total_given_score',
    key: 'total_given_score',
    groupId: 'ALL',
    name: 'responses.filter_condition.score_fields.total_score',
    type: 'DROPDOWN',
    options: FILTER_NUMBER_CONDITIONS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.total_score',
      options: [],
    },
  },
  {
    id: 'ratings.score_percent',
    key: 'score_percent',
    groupId: 'ALL',
    name: 'responses.filter_condition.score_fields.score_percent',
    type: 'DROPDOWN',
    options: FILTER_NUMBER_CONDITIONS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.score_percent',
      options: [],
    },
  },
  {
    id: 'ratings.scoring_group',
    key: 'scoring_group',
    groupId: 'ALL',
    name: 'responses.filter_condition.score_fields.score_group',
    type: 'DROPDOWN',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'channel',
    key: 'channel',
    groupId: 'ALL',
    name: 'responses.filter_condition.response_fields.channel',
    type: 'DROPDOWN',
    options: CHANNELS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'contact_segments',
    key: 'contact_segments',
    groupId: 'ALL',
    name: 'responses.filter_condition.response_fields.responded_from_segment',
    type: 'DROPDOWN',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'contact_lists',
    key: 'contact_lists',
    groupId: 'ALL',
    name: 'responses.filter_condition.response_fields.responded_from_list',
    type: 'DROPDOWN',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'is_comment',
    key: 'is_comment',
    groupId: 'ALL',
    name: 'contacts.import_contact.default_fields.response.comment',
    type: 'DROPDOWN',
    options: COMMENT_OPTIONS,
    placeholder: 'workflow.condition.toggle.all',
    defaultValue: '',
  },
  {
    id: 'is_fav',
    key: 'is_fav',
    groupId: 'ALL',
    name: 'responses.filter_condition.response_fields.favorite',
    type: 'DROPDOWN',
    options: CHECK_TRUTH,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'is_invalid',
    key: 'is_invalid',
    groupId: 'ALL',
    name: 'responses.filter_condition.response_fields.invalid',
    type: 'DROPDOWN',
    options: CHECK_TRUTH,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'is_non_actionable',
    key: 'is_non_actionable',
    groupId: 'ALL',
    name: 'responses.filter_condition.response_fields.non_actionable',
    type: 'DROPDOWN',
    options: CHECK_TRUTH,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'tags',
    key: 'tags',
    groupId: 'ALL',
    name: 'settings.tags.title',
    type: 'MULTISELECT',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: [],
  },
  {
    id: 'ratings.prev_nps_rating',
    key: 'prev_nps_rating',
    groupId: 'NPS',
    name: 'responses.filter_condition.response_fields.previous_rating',
    type: 'DROPDOWN',
    options: FILTER_CONDITIONS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.select_rating',
      options: [],
    },
  },
  {
    id: 'ratings.prev_csat_rating',
    key: 'prev_csat_rating',
    groupId: 'CSAT',
    name: 'responses.filter_condition.response_fields.previous_rating',
    type: 'DROPDOWN',
    options: FILTER_CONDITIONS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.select_rating',
      options: [],
    },
  },
  {
    id: 'ratings.prev_ces_rating',
    key: 'prev_ces_rating',
    groupId: 'CES',
    name: 'responses.filter_condition.response_fields.previous_rating',
    type: 'DROPDOWN',
    options: FILTER_CONDITIONS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.select_rating',
      options: [],
    },
  },
  {
    id: 'ratings.prev_nps_rating_group',
    key: 'prev_nps_rating_group',
    groupId: 'NPS',
    name: 'responses.filter_condition.response_fields.previous_rating_group',
    type: 'DROPDOWN',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'ratings.prev_csat_rating_group',
    key: 'prev_csat_rating_group',
    groupId: 'CSAT',
    name: 'responses.filter_condition.response_fields.previous_rating_group',
    type: 'DROPDOWN',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'ratings.prev_ces_rating_group',
    key: 'prev_ces_rating_group',
    groupId: 'CES',
    name: 'responses.filter_condition.response_fields.previous_rating_group',
    type: 'DROPDOWN',
    options: [],
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
];

export const responseColumnToExclude = ['Rating', 'Comment'];

export const hiddenCustomFieldTypes = [
  'RELATIONSHIP',
  'PHONE_NUMBER',
  'PARAGRAPH',
];
export const hiddenCustomFields = ['is_blocked', 'created_at', 'updated_at'];

export const TRIGGER_STATUS: ConditionsType[] = [
  {
    id: 'queued',
    name: 'responses.filter_condition.trigger_fields.queued',
    value: 'queued',
  },
  // { id: 'survey_sent', name: 'Sent', value: 'survey_sent' },
  // { id: 'survey_reminder', name: 'Reminder', value: 'survey_reminder' },
  // { id: 'survey_dismiss', name: 'Dismissed', value: 'survey_dismiss' },
  // {
  //   id: 'survey_remind_later',
  //   name: 'Snoozed',
  //   value: 'survey_remind_later',
  // },
  // { id: 'open', name: 'Open', value: 'open' },
  // { id: 'processed', name: 'Processed', value: 'processed' },
  // { id: 'delivered', name: 'Delivered', value: 'delivered' },
  // { id: 'dropped', name: 'Dropped', value: 'dropped' },
  {
    id: 'deferred',
    name: 'responses.filter_condition.trigger_fields.deferred',
    value: 'deferred',
  },
  // { id: 'bounce', name: 'Bounced', value: 'bounce' },
  // { id: 'spam', name: 'Marked spam', value: 'spam' },
];

export const TriggerFields: Array<FieldType> = [
  {
    id: 'trigger_filter.created_at',
    key: 'trigger_filter.created_at',
    name: 'responses.filter_condition.response_fields.request_date',
    type: 'DROPDOWN',
    options: DATETIME,
    placeholder: 'forms.placeholders.any_time',
    defaultValue: '',
    subComponent: {
      placeholder: 'forms.placeholders.select_date',
    },
  },
  {
    id: 'trigger_filter.status',
    key: 'trigger_filter.status',
    name: 'responses.filter_condition.response_fields.trigger_status',
    type: 'DROPDOWN',
    options: TRIGGER_STATUS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
  {
    id: 'trigger_filter.channel',
    key: 'trigger_filter.channel',
    name: 'responses.filter_condition.response_fields.channel',
    type: 'DROPDOWN',
    options: CHANNELS,
    placeholder: 'forms.placeholders.any',
    defaultValue: '',
  },
];
